import { EntityBannerType } from '../../shared/components/EntityBanner/constant';
import {
  PipelineDestinationTableSettings,
  PipelineLoadMode,
  SyncFrequencyOption,
  PipelineReplicationTypeMode,
  ReplicationTypeOption
} from '../../shared/interfaces/integration';

export enum PipelineSettingsFeatures {
  LOAD_MODE = 'load_mode',
  PARTITION_KEY = 'partition_key',
  SYNC_FREQUENCY = 'sync_frequency_in_ms',
  SYNC_FREQUENCY_IN_CRON = 'sync_frequency_in_cron',
  SYNC_TYPE = 'sync_type',
  SYNC_FREQUENCY_TYPE = 'sync_frequency_type',
  DESTINATION_TABLE_SETTINGS = 'destination_table_settings',
  REPLICATION_TYPE = 'replication_type',
  PIPELINE_LATENCY = 'latency_threshold_alert_enabled'
}

export interface LoadModeFeatureOptions {
  default_value?: PipelineLoadMode;
  options: {
    label: string;
    value: PipelineLoadMode;
  }[];
}

export interface PipelineDestinationTableSettingsFeatureOptions {
  default_value?: PipelineDestinationTableSettings;
  options: {
    label: string;
    value: PipelineDestinationTableSettings;
  }[];
}

export interface SyncFrequenciesFeatureOptions {
  default_value: number;
  options: SyncFrequencyOption[];
  custom_option: CustomOptionType;
  banner?: SyncFrequencyBannerType;
}

export type SyncFrequencyBannerType = {
  type: EntityBannerType;
  text: string;
};

export interface SyncFrequencyWithCronFeatureOptions {
  custom_option: CustomOptionType;
  default_value?: string;
}

export interface SyncTypeFeatureOptions {
  default_value: SyncType;
  options: SyncTypeFeatureOption[];
}

export interface SyncFrequencyTypeFeatureOptions {
  default_value: string;
  options: SyncFrequencyTypeFeatureOption[];
  banner?: SyncFrequencyBannerType;
}

export interface CommonOption {
  value: string;
  label: string;
  helper_text: { text: string };
}

export type SyncFrequencyTypeFeatureOption = {
  label: string;
  value: SyncFrequencyTypes;
  unit: EligibleFrequencyUnitsInCron;
};

export type SyncTypeFeatureOption = {
  label: string;
  value: SyncType;
  helper_text: {
    text: string;
  };
};

export enum EligibleFrequencyUnitsInCron {
  MINUTES = 'MINUTES',
  HOURS = 'HOURS',
  CRON = 'CRON'
}

export enum SyncFrequencyTypes {
  FIXED = 'FIXED',
  CRON = 'CRON'
}

export enum SyncType {
  ON_DEMAND = 'ON_DEMAND',
  SCHEDULED = 'SCHEDULED'
}

export type CustomOptionType = { time_unit: string; min: number; max: number };

export interface PartitionKeyFeatureOptions {
  default_value: string;
}

export interface PipelineReplicationTypeFeatureOptions {
  default_value: PipelineReplicationTypeMode;
  options: ReplicationTypeOption[];
}

interface PipelineSettingsFeatureMetaDataMap {
  [PipelineSettingsFeatures.LOAD_MODE]: LoadModeFeatureOptions;
  [PipelineSettingsFeatures.PARTITION_KEY]: PartitionKeyFeatureOptions;
  [PipelineSettingsFeatures.SYNC_FREQUENCY]: SyncFrequenciesFeatureOptions;
  [PipelineSettingsFeatures.SYNC_FREQUENCY_IN_CRON]: SyncFrequencyWithCronFeatureOptions;
  [PipelineSettingsFeatures.SYNC_TYPE]: SyncTypeFeatureOptions;
  [PipelineSettingsFeatures.SYNC_FREQUENCY_TYPE]: SyncFrequencyTypeFeatureOptions;
  [PipelineSettingsFeatures.DESTINATION_TABLE_SETTINGS]: PipelineDestinationTableSettingsFeatureOptions;
  [PipelineSettingsFeatures.REPLICATION_TYPE]: PipelineReplicationTypeFeatureOptions;
  [PipelineSettingsFeatures.PIPELINE_LATENCY]: {
    default_value: boolean;
  };
}

export interface PipelineSettingsFeaturesData {
  features: {
    [key in PipelineSettingsFeatures]?: PipelineSettingsFeatureMetaDataMap[key];
  };
}
